import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UpdateValuesArrayType } from '../types/apiResponse/tankTypes'
import { patchData } from '../utils'
import { reloadActiveRelations, reloadBatches, reloadSchool } from '../utils/loadStorage'

const patchUpdateAPI = async (
  updateDate: number,
  updateForm: UpdateValuesArrayType,
  schoolIds: string[],
) => {
  const response = await patchData<string[]>(`/update?update-date=${updateDate}`, updateForm)

  reloadSchool(schoolIds)
  reloadBatches()
  reloadActiveRelations()

  return response
}

export const usePatchUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      updateDate,
      updateForm,
      schoolIds,
    }: {
      updateDate: number
      updateForm: UpdateValuesArrayType
      schoolIds: string[]
    }) => patchUpdateAPI(updateDate, updateForm, schoolIds),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tankInfo'] })
    },

    onError: (error) => {
      console.log('Update API Error:', error)
    },
  })
}
